import React from "react";
import LegalLayout from "../../components/LegalLayout";
import { hotel } from "../../mock";

const CookiePolicy = () => (
  <LegalLayout title="Çerez Politikası" updated="Haziran 2026">
    <p>
      Bu Çerez Politikası, Safranbolu Çelebi Otel web sitesinde çerezlerin nasıl ve
      hangi amaçlarla kullanıldığını açıklamaktadır. Sitemizi kullanarak bu
      politikada belirtilen çerez kullanımını kabul etmiş olursunuz.
    </p>

    <h2>1. Çerez Nedir?</h2>
    <p>
      Çerezler, bir web sitesini ziyaret ettiğinizde tarayıcınıza kaydedilen küçük
      metin dosyalarıdır. Çerezler, sitenin sizi tanımasını, tercihlerinizi
      hatırlamasını ve deneyiminizi iyileştirmesini sağlar.
    </p>

    <h2>2. Neden Çerez Kullanıyoruz?</h2>
    <ul>
      <li>Sitenin temel işlevlerinin çalışmasını sağlamak</li>
      <li>Tercihlerinizi (ör. çerez onayı) hatırlamak</li>
      <li>Site kullanımını analiz ederek performansı iyileştirmek</li>
    </ul>

    <h2>3. Kullandığımız Çerez Türleri</h2>
    <ul>
      <li>
        <strong>Zorunlu Çerezler:</strong> Sitenin düzgün çalışması için gereklidir
        ve devre dışı bırakılamaz.
      </li>
      <li>
        <strong>Performans / Analitik Çerezler:</strong> Ziyaretçilerin siteyi nasıl
        kullandığını anonim olarak analiz etmemize yardımcı olur.
      </li>
      <li>
        <strong>İşlevsellik Çerezleri:</strong> Tercihlerinizi hatırlayarak daha
        kişiselleştirilmiş bir deneyim sunar.
      </li>
    </ul>

    <h2>4. Çerezleri Nasıl Yönetebilirsiniz?</h2>
    <p>
      Tarayıcı ayarlarınız üzerinden çerezleri dilediğiniz zaman silebilir veya
      engelleyebilirsiniz. Ancak zorunlu çerezleri devre dışı bırakmanız durumunda
      sitenin bazı bölümleri düzgün çalışmayabilir. Çoğu tarayıcıda çerez yönetimine
      "Ayarlar &gt; Gizlilik ve Güvenlik" bölümünden ulaşabilirsiniz.
    </p>

    <h2>5. İletişim</h2>
    <p>
      Çerez kullanımıyla ilgili sorularınız için: <strong>{hotel.email}</strong>
    </p>
  </LegalLayout>
);

export default CookiePolicy;
